<template>
  <div class="page page-roadshow-list">
    <a-affix class="affix-title" :target="affixTarget">
      <div class="panel-info-title" style="margin-left: 8px">
        <h2 :title="form.activityName" class="text-ellipsis text-no-wrap overflow-hidden text-bold v-mr-sm">{{ form.activityName }}</h2>
        <a-space class="v-ml-auto">
          <span>表单状态:</span>
          <span v-if="form.activityStatus == 1">已发布</span>
          <span v-if="form.activityStatus == 2">已关闭</span>
          <a-button v-if="form.activityStatus == 1" icon="close" size="small" @click="changeStatus(2)">关闭表单</a-button>
          <a-button v-if="form.activityStatus == 2" icon="caret-right" size="small" @click="changeStatus(1)">发布表单</a-button>
          <a-button v-if="form.activityStatus != 2" icon="edit" size="small" @click="$router.push(`basic-edit?id=${id}`)">编辑表单信息</a-button>
          <a-popconfirm placement="bottomRight" ok-text="删除" cancel-text="取消" @confirm="deleteActivity()">
            <template slot="title">
              <p>确认删除？</p>
            </template>
            <a-button class="v-px-sm" type="primary" icon="delete" size="small">删除</a-button>
          </a-popconfirm>
        </a-space>
      </div>
    </a-affix>
    <a-divider />

    <a-tabs type="card" default-active-key="1">
      <a-tab-pane key="1" tab="表单基本信息">
        <div class="panel-info-section">
          <div class="panel-info-section-title">
            <a-icon type="caret-right" class="text-primary v-mr-xs" />
            <span class="text-bold">表单基本信息</span>
          </div>
          <div style="padding: 10px">
            <table class="table table-plain" style="table-layout: fixed">
              <tbody>
                <tr>
                  <th width="160">表单名称</th>
                  <td width="40%">
                    {{ form.activityName }}
                  </td>
                  <th width="160">表单编号</th>
                  <td>{{ form.activityNo }}</td>
                </tr>
                <tr>
                  <th>表单申请时间</th>
                  <td>
                    <span v-if="form.applyStartdate">{{ form.applyStartdate + ' ~ ' + form.applyEnddate }}</span>
                  </td>
                  <th>表单类型</th>
                  <td>{{ form.activityType ? form.activityType.name : '' }}</td>
                </tr>
                <tr>
                  <th valign="top">表单说明</th>
                  <td colspan="3"><div class="html-container" v-html="form.description"></div></td>
                </tr>
                <tr>
                  <th>对应项目</th>
                  <td>
                    <span v-if="form.projectInfo">{{ form.projectInfo.name }}</span>
                  </td>
                  <th>表单材料</th>
                  <td>
                    <file-container :img-size="[100, 55]" :files="form.files" :belongId="form.id" fileSign="activity"></file-container>
                  </td>
                </tr>
                <tr>
                  <th>表单申请访问链接</th>
                  <td>
                    <router-link tag="a" target="_blank" :to="{ path: '/survey', query: { id: id } }">
                      <span class="text-indigo hover-line">{{ link }}</span>
                    </router-link>
                  </td>
                  <th>表单申请二维码</th>
                  <td>
                    <div>
                      <vue-qr style="height: 200px" :text="qr.text" :size="qr.size" :logoSrc="qr.logoSrc" :logoMargin="qr.logoMargin" :logoScale="qr.logoScale" />
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="panel-info-section" aria-atomic="" v-if="form.instanceExist">
          <div class="panel-info-section-title flex items-center">
            <a-icon type="caret-right" class="text-primary v-mr-xs" />
            <span class="text-bold">配置申请表字段</span>
            <div class="v-ml-auto">
              表单申请表最大填报人数：
              <b v-if="form.instanceLimit == void 0 || form.instanceLimit == -1">不限制</b>
              <b v-else>{{ form.instanceLimit }}</b>
            </div>
          </div>
          <div style="padding: 10px">
            <table class="table table-plain">
              <tbody>
                <tr>
                  <th width="10%" style="text-align: center">序号</th>
                  <th width="20%" style="text-align: left">字段名称</th>
                  <th width="25%" style="text-align: left">字段说明</th>
                  <th width="25%" style="text-align: left">字段类型</th>
                  <th width="20%" style="text-align: left">是否必填</th>
                </tr>
                <tr v-for="(item, index) in form.fieldsConfig" :key="index">
                  <td style="text-align: center">{{ index + 1 }}</td>
                  <td>
                    <span>{{ item.fieldName }}</span>
                  </td>
                  <td>
                    <span>{{ item.fieldDesc }}</span>
                  </td>
                  <td>
                    <span v-if="item.fieldType == 1">单行文本</span>
                    <span v-if="item.fieldType == 2">单选框({{ item.selectVals }})</span>
                    <span v-if="item.fieldType == 3">上传文件</span>
                    <span v-if="item.fieldType == 4">多行文本</span>
                    <span v-if="item.fieldType == 5">多选项({{ item.selectVals }})</span>
                    <span v-if="item.fieldType == 6">日期</span>
                    <span v-if="item.fieldType == 7">数字</span>
                    <span v-if="item.fieldType == 8">小标题</span>
                    <span v-if="item.fieldType == 9">地区</span>
                  </td>
                  <td>
                    <span>{{ item.required ? '是' : '否' }}</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </a-tab-pane>
      <a-tab-pane key="2" tab="表单申请单">
        <div class="panel-info-section">
          <div class="panel-info-section-title">
            <a-icon type="caret-right" class="text-primary v-mr-xs" />
            <span class="text-bold">
              已提交的表单申请表（
              <b :class="{ 'text-primary': pagination.total !== form.instanceLimit }">{{ pagination.total }}</b>
              /
              <span v-if="form.instanceLimit == void 0 || form.instanceLimit == -1">不限制</span>
              <span v-else>{{ form.instanceLimit }}</span>
              ）
            </span>
          </div>
          <a-row>
            <a-col span="17">
              <div class="list-options w100" style="margin-top: 10px">
                <a-form layout="inline" class="options-form">
                  <a-row :gutter="24">
                    <a-col span="6">
                      <a-form-item :colon="false" label="提交人"><a-input placeholder="提交人姓名模糊搜索" allow-clear v-model="searchForm.author" size="default" style="width: 180px" /></a-form-item>
                    </a-col>
                    <a-col span="10">
                      <a-form-item :colon="false" label="提交时间"><a-range-picker v-model="searchForm.createDateRange" /></a-form-item>
                    </a-col>
                  </a-row>
                </a-form>
              </div>
              <div class="flex items-center v-my-sm">
                <div class="v-ml-auto">
                  <a-space>
                    <a-button type="primary" icon="search" size="small" @click="handleSearch">搜索</a-button>
                    <a-button type="indigo" icon="export" size="small" @click="exportData">导出</a-button>
                  </a-space>
                </div>
              </div>
              <div class="list-table-container">
                <div class="list-toolbar flex items-center">
                  <div class="list-toolbar-extra">
                    共
                    <span class="text-primary font-special">{{ pagination.total }}</span>
                    条记录
                  </div>
                  <div class="list-pagination v-ml-auto">
                    <a-pagination size="small" :current="pagination.page" :total="pagination.total" :pageSize="pagination.pageSize" show-size-changer show-quick-jumper @change="onPageChange" @showSizeChange="onPageChange" />
                  </div>
                </div>
                <vxe-table border size="medium" :row-config="{ isCurrent: true, isHover: true }" :radio-config="{ labelField: 'name', trigger: 'row' }" :data="tableData" @radio-change="tableSelectChange">
                  <vxe-column type="seq" width="70" align="center"></vxe-column>
                  <vxe-column v-for="dynamicColum in dynamicColums" :key="dynamicColum.dataIndex" :field="dynamicColum.dataIndex" :title="dynamicColum.title" show-header-overflow show-overflow></vxe-column>
                  <vxe-column field="author" title="提交人"></vxe-column>
                  <vxe-column field="mobile" title="提交人手机号码" align="center" width="160"></vxe-column>
                  <vxe-column field="createTime" title="提交时间" align="center" width="180"></vxe-column>
                  <vxe-column title="操作" align="center" width="100">
                    <template #default="{ row }">
                      <span v-if="hasPermission('activity:form:data:update')" class="hover-line text-indigo" style="margin-right: 10px" title="修改" @click="openFormDataEdit(row.id)">修改</span>
                      <a-popconfirm placement="bottom" ok-text="删除" cancel-text="取消" @confirm="deleteIns(row.id)">
                        <template slot="title">
                          <p>确认删除？</p>
                        </template>
                        <span class="hover-line text-indigo" title="删除">删除</span>
                      </a-popconfirm>
                    </template>
                  </vxe-column>
                </vxe-table>
                <!-- <a-table class="list-table" size="middle" :bordered="false" :pagination="false" :loading="tableLoading" :columns="tableColumns" :data-source="tableData" :scroll="{ x: '100%' }" rowKey="id">
                  <template slot="attachment" slot-scope="text">
                    <file-container v-if="text" :img-size="[100, 55]" :files="[text]" :belongId="text.fileBelongId" fileSign="activity"></file-container>
                  </template>
                  <template slot="action" slot-scope="text, record">
                    <a-popconfirm placement="bottom" ok-text="删除" cancel-text="取消" @confirm="deleteIns(record.id)">
                      <template slot="title">
                        <p>确认删除？</p>
                      </template>
                      <span class="hover-line text-indigo" title="删除">删除</span>
                    </a-popconfirm>
                  </template>
                </a-table> -->
                <div class="list-toolbar flex items-center">
                  <div class="list-toolbar-extra">
                    共
                    <span class="text-primary font-special">{{ pagination.total }}</span>
                    条记录
                  </div>
                  <div class="list-pagination v-ml-auto">
                    <a-pagination size="small" :current="pagination.page" :total="pagination.total" :pageSize="pagination.pageSize" show-size-changer show-quick-jumper @change="onPageChange" @showSizeChange="onPageChange" />
                  </div>
                </div>
              </div>
            </a-col>
            <a-col span="7">
              <a-card hoverable style="width: 96%; min-height: 648px; margin: 10px">
                <a-card-meta title="申请详情">
                  <a-avatar slot="avatar" icon="file-done" size="large" />
                  <div slot="description">
                    <span v-if="Object.keys(selectedRow).length == 0" style="color: #f24a78">点击表格显示申请详情</span>
                    <span style="font-weight: bold; margin-right: 20px">{{ selectedRow.author }}</span>
                    <span>{{ selectedRow.createTime }}</span>
                  </div>
                  },
                </a-card-meta>
                <a-divider />
                <a-empty v-if="!selectedRow || Object.keys(selectedRow).length === 0" style="margin-top: 180px" :description="false" />
                <div v-else>
                  <div v-for="field in selectedRow.fieldConfig ? selectedRow.fieldConfig : this.fieldList" :key="field.key" style="margin-bottom: 15px">
                    <div v-if="field.fieldType != 8">
                      <div style="font-size: 15px">
                        <a-icon type="caret-right" class="text-primary v-mr-xs" />
                        <span class="text-bold">{{ field.fieldName }}</span>
                      </div>
                      <div style="margin-top: 10px; margin-left: 20px">
                        <!-- 单行文本 -->
                        <div v-if="field.fieldType == 1">{{ selectedRow[field.key] }}</div>
                        <!-- 多行文本 -->
                        <div v-if="field.fieldType == 4"><span v-html="selectedRow[field.key]" style="white-space: pre-line"></span></div>
                        <!-- 数字 -->
                        <div v-if="field.fieldType == 7">{{ selectedRow[field.key] }}</div>
                        <!-- 单选框 -->
                        <div v-if="field.fieldType == 2">
                          <a-tag color="pink">
                            {{ selectedRow[field.key] }}
                          </a-tag>
                        </div>
                        <!-- 多选框 -->
                        <div v-if="field.fieldType == 5">
                          <span v-for="item in selectedRow[field.key]" :key="item">
                            <a-tag color="blue" style="margin-bottom: 8px">{{ item }}</a-tag>
                          </span>
                        </div>
                        <!-- 日期 -->
                        <div v-if="field.fieldType == 6">{{ $moment(selectedRow[field.key]).format('YYYY-MM-DD HH:mm:ss') }}</div>
                        <!-- 附件 -->
                        <div v-if="field.fieldType == 3">
                          <file-container v-if="selectedRow[field.key]" :img-size="[300, 150]" :files="selectedRow[field.key]" :belongId="selectedRow[field.key].fileBelongId ? selectedRow[field.key].fileBelongId : 0" fileSign="activity"></file-container>
                        </div>
                        <!-- 省市区 -->
                        <div v-if="field.fieldType == 9">{{ selectedRow[field.key] }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </a-card>

              <!-- <div class="card card-stats card-round" style="margin: 10px 0px 0px 18px; width: 95%; min-height: 100vh; background-color: #fafafa">
                <div style="font-size: 18px; color: #f24a78; font-weight: bold; margin: 10px">反馈详情</div>
                <a-divider style="margin-left: 0 20px; width: 80%" />
                <div class="card-body">
                  <div class="flex items-center"></div>
                </div>
              </div> -->
            </a-col>
          </a-row>
        </div>
      </a-tab-pane>
    </a-tabs>
    <FormDataEdit ref="formDataEdit"></FormDataEdit>
  </div>
</template>

<script>
import { activityDetail, activityInstancePage, updateActivityStatus, removeActivityInstance, activityInstanceExport, deleteActivity } from '@/api/activity'
import VueQr from 'vue-qr'
import alldistricts from '@/utils/districts'
import FormDataEdit from './formdata-edit'

export default {
  components: {
    VueQr,
    FormDataEdit,
  },

  data() {
    return {
      id: this.$route.query.id,
      link: window.location.href.split('/activity/basic/detail')[0] + '/survey?id=' + this.$route.query.id,
      form: {},
      fieldList: [],

      districts: alldistricts,

      searchForm: {},
      tableColumns: [],
      tableLoading: false,
      tableData: [],
      pagination: {
        page: 1,
        pageSize: 20,
        total: 0,
      },
      dynamicColums: [],
      selectedRow: {},

      qr: {
        text: window.location.href.split('/activity/basic/detail')[0] + '/survey?id=' + this.$route.query.id,
        size: 1000,
        logoSrc: require('@/assets/images/logo.png'),
        logoMargin: 5,
        logoScale: 1,
      },
    }
  },
  methods: {
    load() {
      activityDetail({ id: this.id }).then(({ data }) => {
        if (data.success) {
          this.form = { ...data.result }
          let applyDate = []
          applyDate.push(data.result.applyStartdate)
          applyDate.push(data.result.applyEnddate)
          this.form.applyDate = applyDate
          this.fieldList = data.result.fieldsConfig
          this.loadInstances()
        }
      })
    },
    loadInstances(page = 1, pageSize = 20) {
      this.tableLoading = true
      // if (this.tableColumns.length == 0) {
      //   let tableColumns = []
      //   tableColumns.push({
      //     title: '#',
      //     dataIndex: 'id',
      //     width: 60,
      //     align: 'center',
      //     customRender: (text, record, index) => index + 1,
      //   })
      //   tableColumns.push({
      //     title: '操作',
      //     width: 100,
      //     align: 'center',
      //     scopedSlots: { customRender: 'action' },
      //   })
      //   let index = 0
      //   for (let field of this.fieldList) {
      //     let column = {
      //       title: field.fieldName,
      //       dataIndex: this.getKeyByFieldName(field.fieldName),
      //     }
      //     if (field.fieldType == 3) {
      //       column.scopedSlots = { customRender: 'attachment' }
      //     }
      //     tableColumns.push(column)
      //     if (++index == 1) {
      //       break
      //     }
      //   }
      //   this.tableColumns = this.tableColumns.concat(tableColumns)
      //   this.tableColumns.push({ title: '提交人', dataIndex: 'author', align: 'center', width: 200 })
      //   this.tableColumns.push({ title: '提交人手机号码', dataIndex: 'mobile', align: 'center', width: 150 })
      //   this.tableColumns.push({ title: '提交时间', dataIndex: 'createTime', align: 'center', width: 200 })
      // }

      let dynamicColums = []
      let index = 0
      for (let field of this.fieldList) {
        let column = {
          title: field.fieldName,
          dataIndex: this.getKeyByFieldName(field.fieldName),
        }
        if (field.fieldType == 3 || field.fieldType == 8) {
          // 附件和小标题不在列表中显示
          continue
        }
        dynamicColums.push(column)
        if (++index == 3) {
          break
        }
      }
      this.dynamicColums = dynamicColums

      let params = {
        activityBasicId: this.id,
        page,
        pageSize,
        ...this.searchForm,
      }
      let createDateRange = params.createDateRange
      if (createDateRange && createDateRange.length > 0) {
        params.createDateStart = this.$moment(createDateRange[0]).format('YYYY-MM-DD')
        params.createDateEnd = this.$moment(createDateRange[1]).format('YYYY-MM-DD')
      } else {
        params.createDateStart = undefined
        params.createDateEnd = undefined
      }
      activityInstancePage(params).then(({ data }) => {
        if (data.success) {
          let { current, size, total, records } = data.result
          for (let rec of records) {
            for (let k in rec.fieldVals) {
              let value = rec.fieldVals[k]
              if (k.endsWith('#9')) {
                // 处理地区显示格式
                let areaStr = ''
                if (value.area) {
                  areaStr += value.area.join(' ')
                }
                if (value.address) {
                  areaStr += ' ' + value.address
                }
                rec[k] = areaStr
              } else {
                rec[k] = value
              }
            }
          }
          this.tableData = records
          this.pagination = {
            page: current,
            pageSize: size,
            total,
          }
        }
        this.tableLoading = false

        this.selectedRow = {}
      })
    },
    getKeyByFieldName(fieldName) {
      for (let field of this.fieldList) {
        if (fieldName == field.fieldName) {
          return field.key
        }
      }
    },
    changeStatus(status) {
      updateActivityStatus({ id: this.id, status }).then(({ data }) => {
        if (data.success) {
          this.form.activityStatus = status
        }
      })
    },
    onPageChange(page, pageSize) {
      this.loadInstances(page, pageSize)
    },
    handleSearch() {
      this.loadInstances()
    },
    deleteIns(id) {
      removeActivityInstance({ id }).then(({ data }) => {
        if (data.success) {
          this.$message.info('删除成功！')
          this.loadInstances()
        }
      })
    },
    deleteActivity() {
      deleteActivity({ id: this.id }).then(({ data }) => {
        if (data.success) {
          this.$message.info('删除成功！')
          this.$router.push('basic-list')
        }
      })
    },
    exportData() {
      const exporting = this.$message.loading('正在导出..', 0)
      activityInstanceExport({ id: this.id })
        .then(({ data }) => {
          setTimeout(exporting, 200)
          const blob = new Blob([data])
          const fileName = `申请表_${this.form.activityName}.xlsx`
          if ('download' in document.createElement('a')) {
            const dlink = document.createElement('a')
            dlink.download = fileName
            dlink.style.display = 'none'
            dlink.href = URL.createObjectURL(blob)
            document.body.appendChild(dlink)
            dlink.click()
            URL.revokeObjectURL(dlink.href)
            document.body.removeChild(dlink)
          } else {
            // IE10+下载
            navigator.msSaveBlob(blob, fileName)
          }
        })
        .catch(() => {
          setTimeout(exporting, 200)
          this.$message.error('下载文件失败')
        })
    },
    tableSelectChange(e) {
      this.selectedRow = e.row
    },
    openFormDataEdit(record) {
      this.$refs.formDataEdit.open(record)
    },
  },
  mounted() {
    this.load()
    // this.rowDrop()
  },
}
</script>

<style lang="stylus">
.html-container
  img
    max-width 100%
</style>
